import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import LoaderSubmitBtn from 'components/blocks/Buttons/LoaderSubmitBtn';
import DateDouble from 'components/blocks/Inputs/DateDouble';
import RadioCheckGroup from 'components/blocks/Inputs/RadioCheckGroup';
import useDeltaStore from 'stores/useDeltaStore';
import '../Forms.scss';
import './BuscadorDelta.scss';

interface IProps {
  handleFilterRatsbRemesed: (values: any) => void;
  loading: boolean;
}

const BuscadorSinBajaRemesada: React.FC<IProps> = ({ handleFilterRatsbRemesed, loading }) => {
  const ratsbRemesedFilterValues = useDeltaStore((s) => s.ratsbRemesedFilterValues);
  const [resetKey, setResetKey] = useState(0);
  const {
    handleSubmit, reset, watch, formState: { errors },
    register, trigger, setValue,
  } = useForm({ defaultValues: ratsbRemesedFilterValues || {} });

  const handleReset = () => {
    reset({ deltaPart: 'true' });
    setResetKey((k) => k + 1);
  };

  return (
    <form
      className="delta-buscador-form form--simple-styled searcher"
      onSubmit={handleSubmit(handleFilterRatsbRemesed)}
    >
      <div className="delta-buscador-body">

        <RadioCheckGroup
          key={resetKey}
          register={register}
          errors={errors}
          watch={watch}
          setValue={setValue}
        />

        <DateDouble
          key={`date-${resetKey}`}
          register={register}
          errors={errors}
          label="Fecha de accidente"
          watch={watch}
          trigger={trigger}
          setValue={setValue}
        />

      </div>

      <div className="delta-buscador-actions">
        <button
          type="button"
          className="delta-buscador-btn-clear"
          onClick={handleReset}
        >
          Borrar
        </button>
        <LoaderSubmitBtn loading={loading} text="Buscar" />
      </div>
    </form>
  );
};

export default BuscadorSinBajaRemesada;
